import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { FiUser, FiMapPin, FiMail, FiClock, FiDownload } from "react-icons/fi";
import { FaLinkedin, FaGithub, FaTelegram } from "react-icons/fa";
import profile from "../_data/profile.json";

const socialIcons = { LinkedIn: FaLinkedin, GitHub: FaGithub, Telegram: FaTelegram };

const InfoItem = ({ icon: Icon, label, children }) => (
  <li>
    <div className="personalContactInfo">
      <span className="infoIcon">
        <Icon className="icon" aria-hidden="true" />
      </span>
      <div className="mediaWrap">
        <h2 className="infoType">{label}</h2>
        <span className="infoValue">{children}</span>
      </div>
    </div>
  </li>
);

/**
 * Represents the contact information section.
 * Displays the user's contact details and social profiles.
 *
 * @component
 */

const ContactInfo = () => {
  // Using react-intersection-observer to determine if the component is in view
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <motion.div
      className="contactInfo"
      ref={ref}
      initial={{ y: "10vw", opacity: 0 }}
      animate={inView ? { y: 0, opacity: 1 } : { y: "10vw", opacity: 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <h2 className="contentTitle">Contact Information</h2>
      <p className="infoDescription">Let's connect and build something awesome together!</p>
      <ul className="listInfo">
        <InfoItem icon={FiUser} label="Name">
          {profile.name}
        </InfoItem>
        <InfoItem icon={FiMail} label="Email">
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
        </InfoItem>
        <InfoItem icon={FiMapPin} label="Location">
          {profile.location}
        </InfoItem>
        <InfoItem icon={FiClock} label="Time zone">
          {profile.timezone} · remote, worldwide
        </InfoItem>
        {profile.socials.map((social) => (
          <InfoItem key={social.name} icon={socialIcons[social.name]} label={social.name}>
            <a href={social.url} target="_blank" rel="me noopener noreferrer">
              {social.handle}
            </a>
          </InfoItem>
        ))}
        <InfoItem icon={FiDownload} label="CV">
          <a href={profile.cv.pdf} download>
            Download PDF
          </a>{" "}
          ·{" "}
          <a href={profile.cv.docx} download>
            DOCX
          </a>
        </InfoItem>
      </ul>
    </motion.div>
  );
};

export default ContactInfo;
